import * as Styled from './card-item.styles';

export const CardItemSkeleton: React.FC = () => {
  return (
    <Styled.CardContainer>
      <Styled.ImageContainer>
        <Styled.SkeletonProfileImage size="large" />
      </Styled.ImageContainer>
      <Styled.CardContent>
        <div>
          <Styled.SkeletonHeadline
            alignment="center"
            amountRows={1}
            size="medium"
          />
          <Styled.SkeletonBody alignment="center" amountRows={2} />
        </div>
        <Styled.ButtonContainer>
          <Styled.SkeletonButton size="medium" />
        </Styled.ButtonContainer>
      </Styled.CardContent>
    </Styled.CardContainer>
  );
};
